import { Article } from "../../genezio-sdk/westtigermotors";

export const benefits = [
  "5% discount for all bookings",
  "25 Euro Birthday Reward",
  "25 Euro Referral Reward",
  "Faster Check-In",
  "Travel Companion Program",
  "Club Upgrades"
];

export const articleStructuredData = {
  "@context": "http://schema.org",
  "@type": "Organization",
  name: "First Gear Club",
  url: "https://firstgearclub.com",
  logo: "https://firstgearclub.com/assets/img/logo.svg",
  sameAs: [
    "https://www.facebook.com/FirstGearClub",
    "https://www.instagram.com/FirstGearClub",
    "https://www.tiktok.com/@firstgearclub",
    "https://www.youtube.com/@1stgearclub"
  ],
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: "+40 7447 88888",
      contactType: "customer service",
      areaServed: "Romania"
    }
  ]
};

export const articleBlogStructuredData = (article: Article) => {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: article.titleRo,
    image: article.sections
      .map((section) => {
        if (section.graphicType === "photo") {
          return `${process.env.REACT_APP_STORAGE_BASE_URL}/articles/${article?.id}/${section.graphicUrl}`;
        }
        return null;
      })
      .filter((url) => url !== null),
    datePublished: article.createdAt
      ? new Date(article.createdAt).toISOString()
      : null,
    dateModified: article.createdAt
      ? new Date(article.createdAt).toISOString()
      : null,
    author: {
      "@type": "Person",
      name: "Dan B"
    },
    description: article.descriptionRo
  };
};
